import React from "react";
import { styled } from "@mui/material/styles";
import {
    Box,
    DialogTitle,
    DialogActions,
    Button,
    DialogContent,
    Dialog,
    FormControl,
    InputLabel,
    OutlinedInput,
    FormHelperText,
    Typography,
} from "@mui/material";
import Fetching from "../../../Common/Fetching";
import { formatBytes } from "../../../../utilities/formatters";
import SearchIcon from "@mui/icons-material/Search";

const Input = styled("input")({
    display: "none",
});

function ResourceFormDialog(props) {
    const { title, setTitle, description, setDescription, file, setFile } = props;
    const { onUpload, isUploading } = props;
    const { onClose } = props;
    const { action = "Add", type, confirmButton } = props;

    return (
        <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="md">
            <DialogTitle>
                {action} {type}
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                        required={true}
                        error={!title}
                    >
                        <InputLabel id="label-title" sx={{ backgroundColor: "#FFF", padding: "0 4px" }} >
                            Title
                        </InputLabel>
                        <OutlinedInput
                            id="text-title"
                            placeholder="Title"
                            autoFocus={true}
                            value={title}
                            onChange={setTitle}
                            inputProps={{ maxLength: 250 }}
                        />
                        <FormHelperText>Up to 250 characters</FormHelperText>
                    </FormControl>

                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                    >
                        <InputLabel id="label-description" sx={{ backgroundColor: "#FFF", padding: "0 4px" }} >
                            Description
                        </InputLabel>
                        <OutlinedInput
                            id="text-description"
                            placeholder="Description"
                            value={description}
                            onChange={setDescription}
                            multiline
                            rows={2}
                        />
                        <FormHelperText>
                            Include a description here
                        </FormHelperText>
                    </FormControl>

                    {!!setFile && (
                        <>
                            <FormControl
                                component="div"
                                margin={"normal"}
                                fullWidth={true}
                            >
                                <label htmlFor="contained-button-file">
                                    <Input
                                        accept="image/*,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
                                        id="contained-button-file"
                                        type="file"
                                        onChange={setFile}
                                    />
                                    <Button
                                        component="span"
                                        variant="contained"
                                        color="neutral"
                                        disableElevation={true}
                                        aria-label="browse for a file"
                                        startIcon={<SearchIcon />}
                                    >
                                        Browse
                                    </Button>
                                    {!!file && (
                                        <Box component="span" sx={{ paddingLeft: "1em" }} >
                                            {file.name} -{" "}
                                            {formatBytes(file.size)}
                                        </Box>
                                    )}
                                </label>
                            </FormControl>

                            <Box className="form-row">
                                <Typography component="p">
                                    File types:
                                    image/*,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx{" "}
                                </Typography>
                            </Box>
                        </>
                    )}
                </Box>
                {isUploading && <Fetching />}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    onClick={onUpload}
                    disabled={isUploading || !title || (!!setFile && !file)}
                >
                    {confirmButton || action}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ResourceFormDialog;
